import { NgFor } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SafeHtmlPipe } from '@shared/pipes/safe-html.pipe';

type fillType = 'none' | 'half' | 'filled';

const MAX_RATING = 5;

@Component({
  selector: 'ten-card-rating',
  templateUrl: './card-rating.component.html',
  styleUrls: ['./card-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgFor, SafeHtmlPipe, TranslateModule],
})
export class CardRatingComponent implements OnChanges {
  @Input() public ratingLevel = 0;
  @Input() public svgHtml: string;
  public generatedRatingStars: fillType[];

  constructor(private translateService: TranslateService) {}

  public ngOnChanges(): void {
    this.generatedRatingStars = generateRatingStars(this.ratingLevel, MAX_RATING);
  }

  public get ratingText(): string {
    const translationKey = this.ratingLevel <= 1 ? 'HotelAndActivities:Star' : 'HotelAndActivities:Stars';
    return `${this.ratingLevel} ${this.translateService.instant(translationKey)}`;
  }
}

function generateRatingStars(rating: number, total: number): fillType[] {
  const arr: fillType[] = [];

  for (let i = 0; i < total; i++) {
    if (rating > i && rating < i + 1) {
      arr.push('half');
    } else if (rating > i) {
      arr.push('filled');
    } else {
      arr.push('none');
    }
  }

  return arr;
}
